import React from 'react';
import { ProjectId } from 'api/models';
import { useProjectWebsocket } from 'hooks/websockets';

interface Props {
  projectId: number;
}

export const ConditionalSocketSubscriber: React.FC<Props> = ({ projectId }) => {
  useProjectWebsocket(ProjectId(projectId));

  return <></>;
};
